import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Collections } from '@local/client-contracts';
import { Constants } from '@local/common';
import { Icon } from '@local/ui-infra';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CollectionsService } from 'src/app/bar/services/collections.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { collectionContent } from '../../helpers/collection.content';
import { CollectionEmptyStateInfo } from '../../models/collections-empty-state.model';
import { CollectionsUtilService } from 'src/app/bar/services/collections-util.service';

@UntilDestroy()
@Component({
  selector: 'collections-empty-state',
  templateUrl: './collections-empty-state.component.html',
  styleUrls: ['./collections-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionsEmptyStateComponent implements OnInit {
  private readonly notionLink = Constants.LEARN_MORE_COLLECTIONS_URL;
  readonly emptyStateIcon: Icon = {
    lightUrl: 'assets/empty-state/no-collections/empty-collection-light.svg',
    darkUrl: 'assets/empty-state/no-collections/empty-collection-dark.svg',
  };

  collectionContent = collectionContent;
  openNewCollectionSelected: boolean;

  emptyStateCardsContent: CollectionEmptyStateInfo[] = [
    {
      icon: 'icon-curated',
      title: 'Curated Collection',
      messageRow1: collectionContent.staticCollectionMessageRow1,
      messageRow2: collectionContent.staticCollectionMessageRow2,
      messageRow3: collectionContent.staticCollectionMessageRow3,
      imageUrl: {
        lightUrl: 'assets/empty-state/no-collections/curated-collection-empty.svg',
      },
      kind: 'Static',
    },
    {
      icon: 'icon-live-collection',
      title: 'Live Collection',
      messageRow1: collectionContent.liveCollectionMessageRow1,
      messageRow2: collectionContent.liveCollectionMessageRow2,
      messageRow3: collectionContent.liveCollectionMessageRow3,
      imageUrl: {
        lightUrl: 'assets/empty-state/no-collections/live-collection-empty.svg',
      },
      kind: 'Live',
    },
  ];

  constructor(
    private hubService: HubService,
    public collectionsService: CollectionsService,
    private collectionsUtilService: CollectionsUtilService
  ) {}

  ngOnInit(): void {
    this.hubService.preventSearch = true;
    this.openNewCollectionSelected = false;
  }

  async openNewCollection(kind: Collections.Kind) {
    if (this.openNewCollectionSelected) {
      return;
    }
    this.openNewCollectionSelected = true;
    this.collectionsService.openNewCollection(kind, 'new');
  }

  openLearnMore() {
    this.collectionsUtilService.openLearnMore(this.notionLink);
  }
}
